"use client";

import React from "react";
import { t } from "@/utils";
import NewsroomCard from "../NewsroomCard/NewsroomCard";
import { useRouter } from "next-nprogress-bar";
import { pathNames } from "@/lib/constants/pathNames.constants";

type Props = {
	readonly title?: string;
	readonly showPressRelease?: boolean;
	readonly showFirstArticle?: boolean;
	readonly showSecondArticle?: boolean;
};

export default async function Highlights({
	title,
	showPressRelease = true,
	showFirstArticle = true,
	showSecondArticle = true,
}: Props) {
	const router = useRouter();
	return (
		<div className="md:flex">
			<div className="w-full md:w-1/4">
				<h2 className="hmc-title-m pb-6 text-[28px] text-systemInfo">
					{title ? title : t("pages.newsroom.relatedArticles")}
				</h2>
			</div>
			<div className="w-full  md:w-3/4">
				<div className="grid gap-6 md:grid-cols-2">
					{showPressRelease && (
						<NewsroomCard
							img="/assets/newsroom/article_thumbnail_medium_CFS@2x.jpg"
							type={t("pages.newsroom.newsRelease")}
							date="Oct 7, 2024"
							title="Analog Devices Launches Embedded Software Development Environment, CodeFusion Studio™ and Developer Portal "
							description="Simplifying and Speeding Up Development for the Intelligent Edge"
							onClickEvent={() => {
								router.push(pathNames.pressRelease);
							}}
						/>
					)}
					{showFirstArticle && (
						<NewsroomCard
							img="/assets/newsroom/article_thumbnail_medium_embedded@2x.jpg"
							type={t("pages.newsroom.blog")}
							date="Oct 7, 2024"
							title="Equipping Developers for a Multi-Core Heterogeneous Future"
							description="As system architectures become more complex, open solutions can empower engineers and help accelerate the development and adoption of Intelligent Edge solutions."
							onClickEvent={() => {
								router.push(pathNames.article1);
							}}
						/>
					)}
					{showSecondArticle && (
						<NewsroomCard
							img="/assets/newsroom/highlights-pic2.png"
							type={t("pages.newsroom.blog")}
							date="Oct 7, 2024"
							title="Advancing Security at The Intelligent Edge "
							description="With securing embedded systems becoming an increasingly important challenge, simplifying the scalable development, deployment and operation of secure systems is critical."
							onClickEvent={() => {
								router.push(pathNames.article2);
							}}
						/>
					)}
				</div>
			</div>
		</div>
	);
}
